'use strict';

angular.module('TurneroApp').component('coAgendaInicio', {
    bindings: {
        ctrlPadre: '='
    }, controller: [        
        function () {
            var ctrl = this;

            ctrl.limpiarMemoria = function () {
                ctrl.ctrlPadre.consultaAgendas(true);
            };


            ctrl.iniciarNuevaAgenda = function () {
                ctrl.ctrlPadre.inicioAgendaPaso1(true, true, -0);
            };
        }
    ],
    template: require('./agenda_Inicio.html')
});



// WEBPACK FOOTER //
// ./app/components/agenda/agenda_InicioComponent.js